const ReviewForm = ({ errors, register, loading }) => {
  return (
    <div className="writerevw_form">
      <textarea
        className="for_revw_title"
        placeholder="Review title (Optional)"
        {...register('title', { required: true })}
      />
      {errors.title && errors.title.type === 'required' && (
        <span style={{ fontSize: '14px', color: 'red' }}> * Required</span>
      )}
      <br />
      <br />
      <textarea
        placeholder="Description"
        {...register('description', { required: true })}
      />
      {errors.description && errors.description.type === 'required' && (
        <span style={{ fontSize: '14px', color: 'red' }}> * Required</span>
      )}

      <br />
      <button
        type="submit"
        id="btn_submit_revw"
        className="signup_btn submit_revw"
        disabled={loading}
      >
        {loading ? 'Submitting' : 'Submit'}
      </button>
    </div>
  );
};

export default ReviewForm;
